import { ReactComponent as CheckBoxActiveIcon } from '../../assets/icons/check-box-active-icon.svg';
import { ReactComponent as CheckBoxIcon } from '../../assets/icons/check-box-icon.svg';

interface CustomCheckInputProperties {
  inputLabel?: string;
  checkboxLabel: string;
  value: boolean;
  name: string;
  onChangeValue: (name: string, value: boolean) => void;
  valueRequired?: boolean;
  error?: boolean;
  errorMessage?: string;
  fontSize?: 'small' | 'medium' | 'large';
}

/**
 * Check box buttons function component
 */
function CustomCheckbox({
  inputLabel,
  checkboxLabel,
  name,
  value,
  onChangeValue,
  valueRequired,
  error,
  errorMessage,
  fontSize,
}: CustomCheckInputProperties) {
  return (
    <div className={`custom-checkbox-wrap ${fontSize}`}>
      {inputLabel && (
        <p className={`input-label ${error && 'error'}`}>
          {inputLabel}
          {valueRequired && <span>*</span>}
        </p>
      )}
      <div
        className="custom-checkbox-container"
        onClick={() => onChangeValue(name, !value)}
        role="presentation">
        <div className="checkbox-icon">{value ? <CheckBoxActiveIcon /> : <CheckBoxIcon />}</div>
        <div className="checkbox-label">{checkboxLabel}</div>
      </div>
      {error && <p className="custom-input-error-message">{errorMessage}</p>}
    </div>
  );
}

CustomCheckbox.defaultProps = {
  inputLabel: '',
  valueRequired: false,
  error: false,
  errorMessage: '',
  fontSize: 'small',
};

export default CustomCheckbox;
